/* eslint-disable */
// src/forms/localMachine/deleteLocalMachinefromDepositoForm.js

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Container,
  Paper,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import esLocale from "date-fns/locale/es";

import LocalMachineService from "services/localMachineService";
import LocalService from "services/localService";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";
import {
  dateOnlyFromDateTime,
  getDefaultOperationDate,
  isBeforeMinOperationDate,
  isFutureOperationDate,
  isValidOperationDate,
  parseDateOnlyToLocalDate,
  toLocalDateOnlyString,
} from "utils/operationDate";

class DeleteLocalMachinefromDepositoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localMachine: props.localMachine || {},
      depositoLocal: props.depositoLocal || {},
      isDeleting: false,
      desechosLocals: [],
      isLoadingDesechosLocals: true,
      selectedDesecho: null,
      effectiveDate: getDefaultOperationDate(),
      generalError: "",
      showDesechoError: false,
    };
  }

  async componentDidMount() {
    try {
      const desechosLocals = (await LocalService.getActiveLocalDesechosMachines()) || [];

      this.setState({
        desechosLocals,
        isLoadingDesechosLocals: false,
      });
    } catch (error) {
      console.error("Error al cargar locales de desechos:", error);
      this.setState({ isLoadingDesechosLocals: false });
    }
  }

  getDepositoLabel = () => {
    const l = this.state?.depositoLocal || {};
    return l?.Name ?? l?.LocalName ?? `Depósito #${l?.Id ?? "?"}`;
  };

  handleDateChange = (date) => {
    this.setState({ effectiveDate: date, generalError: "" });
  };

  getMinEffectiveDate = () => {
    const machineStartDate = parseDateOnlyToLocalDate(
      dateOnlyFromDateTime(this.state.localMachine?.StartDateTime)
    );
    const desechoCreatedAtDate = parseDateOnlyToLocalDate(
      dateOnlyFromDateTime(this.state.selectedDesecho?.CreatedAt)
    );

    if (!machineStartDate) return desechoCreatedAtDate;
    if (!desechoCreatedAtDate) return machineStartDate;

    return machineStartDate.getTime() >= desechoCreatedAtDate.getTime()
      ? machineStartDate
      : desechoCreatedAtDate;
  };

  getEffectiveDateErrorMessage = () => {
    const { effectiveDate } = this.state;
    const minDate = this.getMinEffectiveDate();
    const hasDesechoCreatedAt = Boolean(this.state.selectedDesecho?.CreatedAt);

    if (!isValidOperationDate(effectiveDate)) {
      return "Selecciona una fecha válida.";
    }
    if (isFutureOperationDate(effectiveDate)) {
      return "No se puede seleccionar una fecha futura.";
    }
    if (minDate && isBeforeMinOperationDate(effectiveDate, minDate)) {
      if (hasDesechoCreatedAt) {
        return "La fecha seleccionada no puede ser anterior al último movimiento de la máquina ni a la fecha de creación del tipo de baja.";
      }
      return "La fecha seleccionada no puede ser anterior al último movimiento de la máquina.";
    }
    return "";
  };

  getApiErrorMessage = (error, fallback) => {
    const status = error?.response?.status;
    const apiError = error?.response?.data?.error || fallback;
    const apiCode = error?.response?.data?.code || "";

    if (status === 409 && apiCode === "EFFECTIVE_DATE_BEFORE_MACHINE_CREATION") {
      return "La fecha seleccionada no puede ser anterior a la fecha de creación de la máquina.";
    }
    if (status === 409 && apiCode === "EFFECTIVE_DATE_BEFORE_CURRENT_LOCAL_MACHINE_START") {
      return "La fecha seleccionada no puede ser anterior al último movimiento de la máquina.";
    }
    if (status === 400 && apiCode === "EFFECTIVE_DATE_CANNOT_BE_FUTURE") {
      return "No se puede seleccionar una fecha futura.";
    }

    return apiError || fallback;
  };

  handleDelete = async () => {
    const { localMachine, depositoLocal, selectedDesecho, effectiveDate } = this.state;

    const depositoLocalId = depositoLocal?.Id ?? null;
    const machineId = localMachine?.MachineId ?? localMachine?.Id ?? null;

    if (!depositoLocalId) {
      this.setState({ generalError: "No se encontró el depósito origen." });
      return;
    }

    if (!machineId) {
      this.setState({ generalError: "No se encontró una máquina válida." });
      return;
    }

    if (!selectedDesecho?.Id) {
      this.setState({ showDesechoError: true, generalError: "" });
      return;
    }

    const effectiveDateError = this.getEffectiveDateErrorMessage();
    if (effectiveDateError) {
      return;
    }

    try {
      this.setState({ isDeleting: true, generalError: "" });

      const activeLocalMachines =
        (await LocalMachineService.getActiveLocalMachineByLocal(depositoLocalId)) || [];

      const matchingLocalMachine = activeLocalMachines.find(
        (lm) => Number(lm.MachineId) === Number(machineId)
      );

      if (!matchingLocalMachine) {
        this.setState({
          isDeleting: false,
          generalError: "No se encontró una LocalMachine activa para esta máquina en el depósito.",
        });
        return;
      }

      const localMachineId = matchingLocalMachine.LocalMachineId ?? matchingLocalMachine.Id;

      await LocalMachineService.discardFromDeposito(
        localMachineId,
        depositoLocalId,
        selectedDesecho.Id,
        toLocalDateOnlyString(effectiveDate)
      );

      this.props.onDeleteSuccess?.();
      this.props.closeForm();
    } catch (error) {
      console.error(
        "DeleteLocalMachinefromDepositoForm: Error al enviar la máquina a desechos:",
        error
      );
      this.setState({
        isDeleting: false,
        generalError: this.getApiErrorMessage(
          error,
          "No se pudo dar de baja la máquina. Intentá nuevamente."
        ),
      });
    }
  };

  render() {
    const {
      isDeleting,
      desechosLocals,
      isLoadingDesechosLocals,
      selectedDesecho,
      effectiveDate,
      generalError,
    } = this.state;
    const minEffectiveDate = this.getMinEffectiveDate();
    const effectiveDateError = this.getEffectiveDateErrorMessage();
    const today = getDefaultOperationDate();

    const depositoLabel = this.getDepositoLabel();

    const getLocalLabel = (loc) =>
      loc?.Name ?? loc?.LocalName ?? `Local #${loc?.Id ?? "?"}`;

    return (
      <Container
        component={Paper}
        style={{ padding: "20px", marginTop: "20px" }}
      >
          <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              Actualmente en: {depositoLabel}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              options={desechosLocals}
              getOptionLabel={(option) => getLocalLabel(option)}
              isOptionEqualToValue={(opt, val) => opt.Id === val.Id}
              value={selectedDesecho}
              onChange={(_e, value) => this.setState({ selectedDesecho: value, showDesechoError: false, generalError: "" })}
              disabled={isLoadingDesechosLocals}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de baja"
                  required
                  placeholder="Seleccioná un tipo de baja"
                  error={this.state.showDesechoError && !selectedDesecho}
                  helperText={this.state.showDesechoError && !selectedDesecho ? "Seleccioná un tipo de baja." : ""}
                  sx={{
                    "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
                      height: 48,
                      py: 0,
                    },
                    "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
                      py: "12px !important",
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
              <DatePicker
                label="Fecha de eliminación"
                value={effectiveDate}
                onChange={this.handleDateChange}
                minDate={minEffectiveDate || undefined}
                maxDate={today}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    required: true,
                    error: Boolean(effectiveDateError),
                    helperText: effectiveDateError,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          {generalError && (
            <Grid item xs={12}>
              <Typography variant="body2" color="error">
                {generalError}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} sx={{ mt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CancelButton
                  onClick={this.props.closeForm}
                  disabled={isDeleting}
                  fullWidth
                >
                  Cancelar
                </CancelButton>
              </Grid>

              <Grid item xs={12} md={6}>
                <AcceptButton
                  type="button"
                  onClick={this.handleDelete}
                  disabled={isDeleting || Boolean(effectiveDateError)}
                  fullWidth
                >
                  {isDeleting ? "Procesando..." : "Dar de baja"}
                </AcceptButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

DeleteLocalMachinefromDepositoForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  depositoLocal: PropTypes.object.isRequired,
  localMachine: PropTypes.object.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};

export default DeleteLocalMachinefromDepositoForm;
